import React from 'react'
import Multiple from 'Components/Multiple'

export default class ComboMulti extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    let val = (this.props.infoTiers === true && this.props.data !== undefined ? this.props.data.id : this.props.data)
    return (
      <Multiple inputStyle={{
                  padding: 0
                }}
                title={this.props.title} options={this.props.options} onChange={this.props.onChange}
                value={val !== undefined ? val : []} inline={this.props.inline}
                disabled={this.props.disabled} libelleEmpty={this.props.libelleEmpty}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboMulti/ComboMulti.js